import axios from 'axios';
import qs from 'qs';

/**
 * 取消重复请求
 */
const request = {
  // pending 的请求
  pendingRequest: new Map(),
  // 用于根据当前请求的信息，生成请求 Key
  genKey(config) {
    /* eslint-disable */
    let { method, url, params, data } = config;

    // response 里面返回的 config.data 是字符串
    if (typeof data === 'string') {
      data = JSON.parse(data);
    }

    return [
      method,
      url,
      qs.stringify(params),
      qs.stringify(data)
    ].join('&');
  },
  // 用于把当前请求信息添加到 pendingRequest 对象
  add(config) {
    // 同一接口不同参数的请求，取消前面的 pending 的请求
    const { method, url } = config;
    const key = method + '&' + url;
    for (const [url, cancelToken] of this.pendingRequest) {
      if (url.startsWith(key)) {
        cancelToken(url);
        this.pendingRequest.delete(url);
      }
    }

    const requestKey = this.genKey(config);
    // 取消请求
    config.cancelToken = config.cancelToken || new axios.CancelToken(cancel => {
      if (!this.pendingRequest.has(requestKey)) {
        this.pendingRequest.set(requestKey, cancel);
      }
    });
  },
  // 检查是否存在重复请求，若存在则取消已发请求
  remove(config) {
    const requestKey = this.genKey(config);
    // 同一接口同一参数的重复请求，取消已发送的请求
    if (this.pendingRequest.has(requestKey)) {
      const cancelToken = this.pendingRequest.get(requestKey);
      cancelToken(requestKey);
      this.pendingRequest.delete(requestKey);
    }
  }
};

export default request;